module.exports = __webpack_public_path__ + "media/images/cvc-f9c3d83a.svg";